import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=2a6c5877&scoped=true&"
import script from "./Tooltip.vue?vue&type=script&lang=ts&"
export * from "./Tooltip.vue?vue&type=script&lang=ts&"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=2a6c5877&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c5877",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
